import React, {forwardRef} from "react";
import {DatePicker} from "antd";
import type {AppRangePickerComponent, AppRangePickerProps} from "./RangePickerBase.types";


export const AppRangePickerBase = forwardRef<AppRangePickerComponent, AppRangePickerProps>(
  (props, ref) => {
    return <DatePicker.RangePicker {...props} ref={ref}/>;
  });
